<template>
  <div class="right-chart-2">
    <div class="rc1-header">运单详情</div>

    <dv-scroll-ranking-board :config="config" style="width:100%;height:100%" />
  </div>
</template>

<script>
export default {
  name: 'RightChart2',
  props: {
    businesses: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    config () {
      let data = this.businesses.map(item => ({
        name: item.receieveCity,
        value: item.statusDesc
      }))
      return {
        data
      }
    }
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="less">
.right-chart-2 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }

  .rc1-chart-container {
    flex: 1;
    display: flex;
  }

  .left {
    width: 30%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    flex: 1;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
</style>
